import React, { useState } from 'react';
import { IconButton } from '@material-ui/core';
import {Settings as TemplateMetaDataIcon} from '@material-ui/icons';
import {TemplateMetaDataDialog} from "../../index";

const TemplateMetaDataCell = ({ template, t }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <IconButton size="small" onClick={handleOpen}>
                <TemplateMetaDataIcon />
            </IconButton>

            <TemplateMetaDataDialog
                open={open}
                template={template}
                onClose={handleClose}
                t={t}
            />
        </>
    );
};

export default TemplateMetaDataCell;
